/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ifNotAuthenticated } from '../routeValidation';

import AuthenticationLayout from '@/views/Layout/AuthenticationLayout.vue';
import { RouteConfig } from 'vue-router';
import { ROUTES } from './routes';

const { LOGIN, } = ROUTES;
const Login = () =>
  import(/* webpackChunkName: "Login" */ '@/views/Login/Login.vue');
export const LoginRoutes: RouteConfig = {
  path: '/auth',
  component: AuthenticationLayout,
  beforeEnter: ifNotAuthenticated,
  children: [
    {
      path: LOGIN.route,
      name: LOGIN.name,
      component: Login,
    }
  ],
};
